export default __webpack_public_path__ + "static/media/with_mom.3489a4cc.jpg";